import { GetterTree } from 'vuex';

// Shared types
import { Map, System } from '@coldtec/cos-types';

// Store and store types
import Store from '@/store';
import {
    RootState,
    SystemsGetter,
    SystemsFilters,
    SystemsFilterGroup,
    ToolSpace,
    ToolSystem,
    ToolSystemSuggestionMap,
    ToolSystemSuggestion,
    SelectedToolSystems,
} from '@/store/store.types';

/**
 *  Holding every getter of the systems.
 */
export const Getters: GetterTree<RootState, RootState> = {

    /**
     *  Used to get the available filters.
     */
    [SystemsGetter.FILTERS_AVAILABLE](state: RootState): Array<SystemsFilterGroup> {

        return state.systems.filters.available;

    },

    /**
     *  Used to get the state of the filter(s).
     */
    [SystemsGetter.FILTER_STATE](state: RootState): SystemsFilters {

        return state.systems.filters.state;

    },

    /**
     *  Used to get the general active state of the filter(s).
     */
    [SystemsGetter.FILTER_ACTIVE](state: RootState): boolean {

        let active = false;

        for (const options of Object.values(state.systems.filters.state)) {

            for (const filterActive of Object.values(options)) {

                if (filterActive) {

                    active = true;

                    break;

                }

            }

            if (active) {

                break;

            }

        }

        return active;

    },

    /**
     *  Used to get all the single split system suggestions.
     */
    [SystemsGetter.SUGGESTIONS_SINGLE](state: RootState): ToolSystemSuggestionMap {

        return state.systems.suggestions.single;

    },

    /**
     *  Used to get all the multi split system suggestions.
     */
    [SystemsGetter.SUGGESTIONS_MULTI](state: RootState): ToolSystemSuggestionMap {

        return state.systems.suggestions.multi;

    },


    /**
     *  Used to get all the system suggestions.
     */
    [SystemsGetter.SUGGESTIONS_ALL](state: RootState): ToolSystemSuggestionMap {

        return {
            ...state.systems.suggestions.single,
            ...state.systems.suggestions.multi,
        };

    },

    /**
     *  Used to get all the selected system suggestions.
     */
    [SystemsGetter.SUGGESTIONS_SELECTED](): SelectedToolSystems {

        const selected = {} as SelectedToolSystems;

        for (const [ toolSpaceIds, suggestion ] of Object.entries<ToolSystemSuggestion>(Store.getters[SystemsGetter.SUGGESTIONS_ALL])) {

            for (const system of suggestion.systems) {

                if (!system.selected) {

                    continue;

                }

                selected[toolSpaceIds] = system;

                break;

            }

        }

        return selected;

    },

    /**
     *  Used to get all the system suggestions of the currently showing space.
     */
    [SystemsGetter.SUGGESTIONS_OF_SHOWING_SPACE](state: RootState): Array<ToolSystem> {

        const showSystemSpaceId: string | null = state.systems.suggestions.show;

        if (!showSystemSpaceId) {

            return [];

        }

        return Object.values(Store.getters[SystemsGetter.SUGGESTIONS_ALL][showSystemSpaceId].systems);

    },

    /**
     *  Used to get all the systems that were suggested.
     */
    [SystemsGetter.SUGGESTIONS_SYSTEMS](state: RootState): Map<System> {

        return state.systems.suggestions.systems;

    },

    /**
     *  Used to get the (tool) space(s) for which the suggestions are currently shown.
     */
    [SystemsGetter.SPACES](state: RootState): Array<ToolSpace> {

        const spaces: Array<ToolSpace> = [];
        const systemSpaceId: string | null = state.systems.suggestions.show;

        if (systemSpaceId) {

            for (const toolSpaceId of systemSpaceId.split('-')) {

                spaces.push(state.spaces.added[toolSpaceId]);

            }

        }

        return spaces;

    },

};
